import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./MobileNavigation.module.scss";

import reservationNav from "../../assets/hospitalReservation/ReservationNav.png";
import reservationNavActive from "../../assets/hospitalReservation/ReservationNavActive.png";
import myReservationNav from "../../assets/hospitalReservation/MyReservationNav.png";
import myReservationNavActive from "../../assets/hospitalReservation/MyReservationActive.png";
import myInfoNav from "../../assets/hospitalReservation/MyInfoNav.png";
import myInfoNavActive from "../../assets/hospitalReservation/MyInfoActive.png";

import { useTranslation } from 'react-i18next';

interface NavItem {
  label: string;
  icon: string;
  activeIcon: string;
  path: string;
}

const MobileNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const savedLanguage = localStorage.getItem('selectedLanguage') || 'en';

    if (i18n.language !== savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);
  
  const navItems: NavItem[] = [
    {
      label: t('mobileNavigation.hospitalReservation'),
      icon: reservationNav,
      activeIcon: reservationNavActive,
      path: "/treatment-list",
    },
    {
      label: t('mobileNavigation.myReservation'),
      icon: myReservationNav,
      activeIcon: myReservationNavActive,
      path: "/my-reservation",
    },
    {
      label: t('mobileNavigation.memberInformation'),
      icon: myInfoNav,
      activeIcon: myInfoNavActive,
      path: "/myPage",
    },
  ];

  return (
    <div className={styles.mobileNav}>
      {navItems.map((item) => {
        const isActive = location.pathname === item.path;

        return (
          <div
            key={item.label}
            className={`${styles.navItem} ${isActive ? styles.active : ""}`}
            onClick={() => navigate(item.path)}
          >
            <img
              src={isActive ? item.activeIcon : item.icon}
              alt={item.label}
              className={styles.icon}
            />
            <span className={isActive ? styles.activeLabel : ""}>{t(item.label)}</span>
          </div>
        );
      })}
    </div>
  );
};

export default MobileNavigation;
